<template>
  <div class="d-flex align-items-center me-2 ms-2">
    <div class="navbar-complex-select2-container position-relative">
      <div class="status-indicator-container compass-icon-nav">
        <img :src="require('@/assets/icons/icons8-compass-100.png')" class="w-24px h-24px rounded-pill" alt=""
          style="background-color: white;" />
        <span class="status-indicator bg-success"></span>
      </div>

      <select ref="refComplexNav" class="form-control select-complex" v-model="selectedComplex">
        <optgroup label="El Salvador" v-if="groupedComplexes.ElSalvadorPorts.length">
          <option v-for="item in groupedComplexes.ElSalvadorPorts" :key="item.PKey" :value="item.PKey">
            YILPORT {{ item?.Description || item?.Name }}
          </option>
        </optgroup>
        <optgroup label="Ghana" v-if="groupedComplexes.GhanaPorts.length">
          <option v-for="item in groupedComplexes.GhanaPorts" :key="item.PKey" :value="item.PKey">
            YILPORT {{ item?.Description || item?.Name }}
          </option>
        </optgroup>
        <optgroup label="Guatemala" v-if="groupedComplexes.GuatemalaPorts.length">
          <option v-for="item in groupedComplexes.GuatemalaPorts" :key="item.PKey" :value="item.PKey">
            YILPORT {{ item?.Description || item?.Name }}
          </option>
        </optgroup>
        <template v-if="groupedComplexes.TransitexGroups.length">
          <optgroup v-for="group in groupedComplexes.TransitexGroups" :key="group.label" :label="group.label">
            <option v-for="item in group.items" :key="item.PKey" :value="item.PKey">
              {{ item?.Description || item?.Name }}
            </option>
          </optgroup>
        </template>
        <optgroup label="Other" v-if="groupedComplexes.OtherPorts.length">
          <option v-for="item in groupedComplexes.OtherPorts" :key="item.PKey" :value="item.PKey">
            {{ item?.Description || item?.Name }}
          </option>
        </optgroup>
      </select>
    </div>
  </div>
</template>
<script>
import { useAuthAppStore } from "@/store/stores/authStore.js";
import $ from 'jquery';
import 'select2';

export default {
  // name: "LoginPage",
  data() {
    return {
      // userInfo: null,
      useAuthAppStore: useAuthAppStore(),
      selectedComplex: useAuthAppStore().getSelectedComplex
    }
  },
  mounted() {
    this.initSelect2();
  },
  computed: {
    groupedComplexes() {
      const complexes = this.useAuthAppStore.getComplexesByUserName || [];
      const result = {
        ElSalvadorPorts: [],
        GhanaPorts: [],
        GuatemalaPorts: [],
        TransitexGroups: [],
        OtherPorts: []
      };

      const addToTransitexGroup = (label, port) => {
        let group = result.TransitexGroups.find(g => g.label === label);
        if (!group) {
          group = { label: label, items: [] };
          result.TransitexGroups.push(group);
        }
        group.items.push(port);
      };

      complexes.forEach(port => {
        const name = port.Name || "";
        const region = port.Region || "";

        if (name.startsWith("TX_")) {
          if (name.startsWith("TX_PT")) addToTransitexGroup("Transitex Portugal", port);
          else if (name.startsWith("TX_ES")) addToTransitexGroup("Transitex Spain", port);
          else if (name.startsWith("TX_TR")) addToTransitexGroup("Transitex Turkey", port);
          else if (name.startsWith("TX_MZ")) addToTransitexGroup("Transitex Mozambique", port);
          else if (name.startsWith("TX_PE")) addToTransitexGroup("Transitex Peru", port);
          else if (name.startsWith("TX_CO")) addToTransitexGroup("Transitex Colombia", port);
          else if (name.startsWith("TX_US")) addToTransitexGroup("Transitex USA", port);
          else if (name.startsWith("TX_SV")) addToTransitexGroup("Transitex El Salvador", port);
          else if (name.startsWith("TX_BR")) addToTransitexGroup("Transitex Brasil", port);
          else addToTransitexGroup("Transitex Other", port);

        } else if (region === "EL" || name === "ACAJUTLA" || name === "LAUNION") {
          result.ElSalvadorPorts.push(port);
        } else if (region === "AF" || name === "TAKORADI") {
          result.GhanaPorts.push(port);
        } else if (region === "CA" || name === "QUETZAL") {
          result.GuatemalaPorts.push(port);
        } else {
          result.OtherPorts.push(port);
        }
      });

      const sortOrder = [
        "Transitex Portugal", "Transitex Spain", "Transitex Turkey",
        "Transitex Mozambique", "Transitex Peru", "Transitex Colombia",
        "Transitex USA", "Transitex El Salvador", "Transitex Brasil"
      ];

      result.TransitexGroups.sort((a, b) => {
        return sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label);
      });

      return result;
    }
  },
  methods: {
    initSelect2() {
      const glbThis = this;
      this.$nextTick(() => {
        $(this.$refs.refComplexNav).select2({
          dropdownParent: $('.navbar-complex-select2-container'),
          width: 'resolve'
        })
          .on('change', function () {
            glbThis.onComplexChange($(this).val());
          });
      });
    },
    onComplexChange(complexId) {
      const parsedId = typeof complexId === "string" ? parseInt(complexId, 10) : complexId;

      if (this.selectedComplex === parsedId)
        return false

      // Seçilen kompleksi güncelle
      this.selectedComplex = parsedId;

      // Burada istediğiniz metodu çağırabilirsiniz
      console.log("Seçilen kompleks değişti:", parsedId);

      // Örnek olarak bir API çağrısı veya başka bir işlem eklenebilir:
      this.useAuthAppStore.setSelectedComplex(parsedId);
      document.location.href = "/"
    },
  },
}
</script>
<style scoped>
.navbar-complex-select2-container {
  min-width: 250px;
  display: flex;
  align-items: center;
}

.compass-icon-nav {
  position: absolute;
  left: 8px;
  z-index: 5;
  pointer-events: none;
  display: flex;
  align-items: center;
}

:deep(.select2-container--default .select2-selection--single) {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 50rem !important;
  color: inherit !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  height: 38px !important;
  padding: 0 35px 0 40px !important;
  transition: all 0.2s ease-in-out;
  width: 100% !important;
}

:deep(.select2-container--default .select2-selection--single:hover) {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  line-height: 36px !important;
  padding-left: 0;
  color: inherit !important;
  width: 100%;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 36px !important;
  right: 10px !important;
  width: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow b) {
  border-color: rgba(255, 255, 255, 0.6) transparent transparent transparent !important;
  border-width: 5px 4px 0 4px !important;
}

:deep(.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b) {
  border-color: transparent transparent rgba(255, 255, 255, 0.6) transparent !important;
  border-width: 0 4px 5px 4px !important;
}

:deep(.select2-dropdown) {
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  z-index: 1050;
  margin-top: 5px;
  overflow: hidden;
}

:deep(.select2-search--dropdown::after) {
  display: none !important; /* Limitless temasından gelen sol magnifier pseudo-icon'u gizle */
}

:deep(.select2-search__field) {
  border-radius: 4px !important;
  border: 1px solid #ddd !important;
  padding: 6px 30px 6px 10px !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23999' viewBox='0 0 256 256'%3E%3Cpath d='M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z'%3E%3C/path%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 10px center !important;
  background-size: 16px !important;
}

:deep(.select2-results__option--highlighted[aria-selected]) {
  background-color: rgba(0, 123, 255, 0.15) !important;
  color: #0056b3 !important;
}

:deep(.select2-results__option[aria-selected=true]) {
  background-color: rgba(0, 123, 255, 0.1) !important;
  color: #0056b3 !important;
}
</style>
